// 個人資料相關翻譯

export const profile = {
    username: '用戶名',
    enterUsername: '請輸入您的用戶名',
    characters: '個字符',
    noChangesDetected: '未檢測到更改',
    profileUpdatedSuccessfully: '個人資料更新成功！',
    updateFailed: '更新失敗，請重試',
    updating: '更新中...',
    saveChanges: '儲存更改'
  };
